export default __webpack_public_path__ + "static/clientBg-2d3092a40dc8a720cc7004d88dd406d6.png";